export const translations = {
  '参加する': { en: 'Join' },
  '退室': { en: 'Leave' },
  '閉じる': { en: 'Close' },
  'キャンセル': { en: 'Cancel' },
  '保存': { en: 'Save' },
  '保存する': { en: 'Save' },
  '更新': { en: 'Update' },
  '編集': { en: 'Edit' },
  '削除': { en: 'Delete' },
  '削除する': { en: 'Delete' },
  '作成': { en: 'Create' },
  '作成する': { en: 'Create' },
  '確定': { en: 'Done' },
  '送信': { en: 'Send' },
  '投稿': { en: 'Post' },
  'タイトル': { en: 'Title' },
  'ニックネーム': { en: 'Nickname' },
  '自己紹介': { en: 'Bio' },
  '検索': { en: 'Search' },
  '返信': { en: 'Reply' },
  '返信をやめる': { en: 'Cancel reply' },
  '雑談用チャット': { en: 'Chat' },
  'メッセージがまだありません': { en: 'No messages yet' },
  '最新のメッセージへ移動': { en: 'Latest messages' },
  'プロフィール編集': { en: 'Edit profile' },
  'イラスト一覧': { en: 'Works' },
  'アルバム一覧': { en: 'Albums' },
  '違反報告': { en: 'Report' },
  'アルバムへ追加': { en: 'Add to album' },
  'アルバムがまだありません': { en: 'No albums yet' },
  '公開': { en: 'Public' },
  '非公開': { en: 'Private' },
  '追加': { en: 'Add' },
  'イラストを編集': { en: 'Edit work' },
  'タグ（半角スペース区切り）': { en: 'Tags (space-separated)' },
  'イラスト一覧でピン止めする': { en: 'Pin to works' },
  'コメント': { en: 'Comments' },
  'まだコメントがありません': { en: 'No comments yet' },
  'コメントを送信': { en: 'Post comment' },
  'スタンプをつけた人': { en: 'Reactions' },
  '新規アルバム': { en: 'New album' },
  'アルバムを編集': { en: 'Edit album' },
  'アルバム名': { en: 'Album name' },
  'アルバム名を入力': { en: 'Album name' },
  '公開設定': { en: 'Visibility' },
  'プロフィールに表示されます': { en: 'Shown on your profile' },
  '自分だけが見ることができます': { en: 'Only you can view it' },
  'アルバムを削除': { en: 'Delete album' },
  'アルバムを削除しますか？': { en: 'Delete this album?' },
  'アルバムを削除しても、元のイラストは削除されません。': { en: 'The original works will remain.' },
  'アルバムの並べ替え': { en: 'Reorder albums' },
  '新規アルバムを作成': { en: 'New album' },
  '並べ替え': { en: 'Reorder' },
  'イラストを整理': { en: 'Organize works' },
  'イラストがありません': { en: 'No works' },
  'ブックマークしたユーザー': { en: 'Bookmarked users' },
  'ブックマークしたユーザーがいません': { en: 'No bookmarked users' },
  '設定': { en: 'Settings' },
  '通知': { en: 'Notifications' },
  'アカウント': { en: 'Account' },
  'ログイン': { en: 'Log in' },
  'ログアウト': { en: 'Log out' },
  'ユーザーID': { en: 'User ID' },
  'パスワード': { en: 'Password' },
  '新規登録': { en: 'Get started' },
  '音声': { en: 'Sound' },
  'プッシュ通知': { en: 'Push notifications' },
  'プッシュ通知を登録': { en: 'Enable notifications' },
  'プッシュ通知登録済み': { en: 'Notifications enabled' },
  'プッシュ通知の個別設定': { en: 'Notification settings' },
  '通知を許可する': { en: 'Allow notifications' },
  'プッシュ通知は有効です': { en: 'Notifications are enabled' },
  'イラストへのコメント': { en: 'Comments on works' },
  '使い方': { en: 'Help' },
  'ペイントツールの使い方': { en: 'Drawing guide' },
  'よくある質問': { en: 'FAQ' },
  'お問い合わせフォーム': { en: 'Contact' },
  'アカウント設定': { en: 'Account settings' },
  'ルームの名前': { en: 'Room name' },
  '新規プライベートルーム': { en: 'New private room' },
  'ゲストさん': { en: 'Guest' },
  '参加中': { en: 'Joined' },
  '見学中': { en: 'Viewing' },
  'イラストを投稿': { en: 'Post work' },
  'タグ（半角スペース区切りで複数）': { en: 'Tags (space-separated)' },
  'キャンバスのリセット': { en: 'Reset canvas' },
  'キャンバスをリセット': { en: 'Reset' },
  '共通設定': { en: 'General' },
  'ペンと消しゴムの設定を連動': { en: 'Sync pen and eraser' },
  '手ブレ補正': { en: 'Stabilizer' },
  '元に戻せる回数': { en: 'Undo levels' },
  '筆圧': { en: 'Pressure' },
  '太さ': { en: 'Size' },
  '濃さ': { en: 'Opacity' },
  '疑似筆圧': { en: 'Simulated pressure' },
  '入り': { en: 'Start' },
  '抜き': { en: 'End' },
  'ニックネームの設定': { en: 'Choose a nickname' },
  '作成済みユーザーにログイン': { en: 'Log in to existing user' },
  'Googleログインは有効です': { en: 'Google login enabled' },
  'パスワードでログイン': { en: 'Log in with password' },
  'パスワードを変更': { en: 'Change password' },
  'パスワードを設定': { en: 'Set password' },
  'パスワード（確認）': { en: 'Confirm password' },
  'パスワードが一致しません': { en: 'Passwords do not match' },
  'パスワードを忘れた場合': { en: 'Forgot password?' },
  '環境設定': { en: 'Preferences' },
  '音声を許可': { en: 'Sound' },
  'チャットのポップアップを表示': { en: 'Chat popups' },
  'イラストのポップアップを表示': { en: 'Work popups' },
  '入室のポップアップを表示': { en: 'Join popups' },
  'フィードバック': { en: 'Feedback' },
  'アカウント管理': { en: 'Manage account' },
  '再ログイン方法設定': { en: 'Login settings' },
  'アカウントを削除': { en: 'Delete account' },
  'イラストタグ': { en: 'Work tag' },
  'ユーザー名': { en: 'Username' },
  'タグ名（完全一致）': { en: 'Exact tag' },
  'ユーザーID（完全一致）': { en: 'Exact user ID' },
  'ユーザー名（部分一致）': { en: 'Username' },
  '検索を開く': { en: 'Open search' },
  '検索モード': { en: 'Search mode' },
  '検索キーワード': { en: 'Search query' },
  '人気のタグ': { en: 'Popular tags' },
  '読み込み中...': { en: 'Loading...' },
  '利用停止解除リクエストの更新': { en: 'Suspension request updates' },
  'ペイントツール': { en: 'Drawing tools' },
  '元に戻す': { en: 'Undo' },
  'やり直す': { en: 'Redo' },
  'ペン': { en: 'Pen' },
  '塗りつぶし': { en: 'Fill' },
  '消しゴム': { en: 'Eraser' },
  'スポイト': { en: 'Eyedropper' },
  '選択': { en: 'Select' },
  '拡大': { en: 'Zoom' },
  '等倍に戻す': { en: 'Reset zoom' },
  'レイヤー': { en: 'Layers' },
  'カラー': { en: 'Color' },
  'キャプション': { en: 'Caption' },
  'バックアップ': { en: 'Backup' },
  '描画設定': { en: 'Drawing settings' },
  '端末に保存': { en: 'Save to device' },
  '端末から読み込み': { en: 'Load from device' },
  'キャンバス': { en: 'Canvas' },
  'リセット': { en: 'Reset' },
  'レイヤー結合色を取る': { en: 'Sample merged color' },
  '拡大率': { en: 'Zoom' },
  'しきい値': { en: 'Threshold' },
  '表示中レイヤーを結合して判定': { en: 'Sample visible layers' },
  'ブラシ': { en: 'Brush' },
  '背景表示を切り替え': { en: 'Toggle background' },
  '名前の変更': { en: 'Rename' },
  'レイヤーの複製': { en: 'Duplicate layer' },
  '色調を変更': { en: 'Adjust color' },
  '色相': { en: 'Hue' },
  '彩度': { en: 'Saturation' },
  '明度': { en: 'Lightness' },
  '決定': { en: 'Apply' },
  '下のレイヤーと結合': { en: 'Merge down' },
  '透明部分の保護を解除': { en: 'Unlock transparency' },
  '透明部分を保護': { en: 'Lock transparency' },
  '不透明度': { en: 'Opacity' },
  '合成モード': { en: 'Blend mode' },
  '{name}さんの違反を報告': { en: 'Report {name}' },
  '送信が完了しました': { en: 'Report sent' },
  '選択してください': { en: 'Choose a reason' },
  '発言や利用マナーに少し問題がある': { en: 'Minor conduct issue' },
  '暴言等の明らかな違反行為': { en: 'Clear violation or abuse' },
  '違反内容を入力してください': { en: 'Describe the violation' },
  '違反報告を送信': { en: 'Send report' },
  '※ 虚偽の違反報告には厳格な措置が講じられます': { en: 'False reports may result in suspension.' },
  '「{query}」のユーザー検索結果': { en: 'Users matching “{query}”' },
  '検索に失敗しました': { en: 'Search failed' },
  '一致するユーザーはいませんでした': { en: 'No matching users' },
  '登録日': { en: 'Joined' },
  'Googleログイン': { en: 'Google login' },
  'ブックマークから削除': { en: 'Remove bookmark' },
  'ブックマーク': { en: 'Bookmark' },
  'お知らせ': { en: 'News' },
  '当サイトについて': { en: 'About' },
  '公開ルーム': { en: 'Public rooms' },
  'プライベートルーム': { en: 'Private rooms' },
  '[新規作成]': { en: '[New room]' },
  '[入室履歴の整理]': { en: '[Edit history]' },
  '参加者がいません': { en: 'No one is here' },
  'へ返信': { en: 'Replying to' },
  'メッセージのメニューを開く': { en: 'Open message menu' },
  'LIVE中': { en: 'LIVE' },
  'タップで視聴': { en: 'Tap to watch' },
  '設定パネルを左へ移動': { en: 'Move settings left' },
  '設定パネルを右へ移動': { en: 'Move settings right' },
  'YYYY/MM/DD H:mm': { en: 'MMM D, YYYY, h:mm A' },
  'YYYY/MM/DD': { en: 'MMM D, YYYY' },
  'M/D H:mm': { en: 'MMM D, h:mm A' },
  'H:mm': { en: 'h:mm A' },
  'これ以上ブックマークできません': { en: 'You cannot add more bookmarks.' },
  'ユーザー登録が拒否されました': { en: 'Registration was declined.' },
  'ユーザーの作成に失敗しました': { en: 'Could not create the user.' },
  'パスワードを設定しました': { en: 'Password saved.' },
  'パスワードの設定に失敗しました': { en: 'Could not save the password.' },
  'エラーが発生しました': { en: 'Something went wrong.' },
  'Google連携を解除してよろしいですか？': { en: 'Disconnect Google?' },
  'ログイン不能になることを防ぐため、先にパスワードを設定してください': { en: 'Set a password before disconnecting Google.' },
  'Google連携の解除に失敗しました': { en: 'Could not disconnect Google.' },
  'これ以上のコメントを連続して投稿することはできません': { en: 'You cannot post more comments in a row.' },
  'コメントの内容が不適切な可能性があります。表現を修正のうえ再度送信してください。繰り返された場合は利用停止となりますのでご注意ください。': { en: 'This comment may be inappropriate. Please revise it before posting again.' },
  'コメントの投稿に失敗しました': { en: 'Could not post the comment.' },
  'このコメントを削除しますか？（元に戻せません）': { en: 'Delete this comment? This cannot be undone.' },
  'コメントの削除に失敗しました': { en: 'Could not delete the comment.' },
  'このイラストにつけられた「{stamp}」のスタンプをすべて削除しますか？（元に戻せません）': { en: 'Delete all “{stamp}” reactions from this work? This cannot be undone.' },
  'スタンプの削除に失敗しました': { en: 'Could not delete the reactions.' },
  '「違反報告をした」「違反報告をする」等の発言はお控えください。違反行為を見つけた場合、違反報告を送信のうえ、そのまま対応までお待ちください。': { en: 'Please do not discuss reports in chat. Submit a report and wait for it to be reviewed.' },
  '荒らし防止のため、連続投稿が制限されています。しばらくしてから再度お試しください。': { en: 'Posting is temporarily limited. Please try again later.' },
  '送信に失敗しました': { en: 'Could not send.' },
  'アルバムを取得できませんでした': { en: 'Could not load albums.' },
  'アルバムに追加できませんでした': { en: 'Could not add to the album.' },
  '※再ログイン方法が設定されていないため、ログアウトするとこのアカウントには復帰できません。本当にログアウトしますか？': { en: 'No login method is set. If you log out, you cannot recover this account. Log out anyway?' },
  '本当にログアウトしますか？再ログインには「ユーザーID」と設定済みの「パスワード」の入力が必要です。': { en: 'Log out? You will need your user ID and password to log in again.' },
  '本当にログアウトしますか？': { en: 'Log out?' },
  'アカウントを削除できませんでした': { en: 'Could not delete the account.' },
  '※再ログイン方法が設定されていないため、ログインセッションが切れた場合同じアカウントへ復帰することができません。': { en: 'No login method is set. You cannot recover this account if your session expires.' },
  'このイラストを削除してよろしいですか？（一度削除したイラストは元に戻せません）': { en: 'Delete this work? This cannot be undone.' },
  'アルバムを保存できませんでした': { en: 'Could not save the album.' },
  'アルバムを削除できませんでした': { en: 'Could not delete the album.' },
  '並び順を保存できませんでした': { en: 'Could not save the order.' },
  'イラストの更新に失敗しました': { en: 'Could not update the work.' },
  'プロフィールの保存に失敗しました': { en: 'Could not save the profile.' },
  'イラストを取得できませんでした': { en: 'Could not load works.' },
  'イラストの整理結果を保存できませんでした': { en: 'Could not save the work order.' },
  '違反報告に失敗しました': { en: 'Could not send the report.' },
  '塗りつぶしに失敗しました': { en: 'Fill failed.' },
  '※レイヤー数が多いとパフォーマンス低下やクラッシュにつながる恐れがあります': { en: 'Too many layers may reduce performance or cause a crash.' },
  'レイヤー「{name}」を削除しますか？': { en: 'Delete layer “{name}”?' },
  'レイヤー名の変更': { en: 'Rename layer' },
  'イラストのバックアップを保存できませんでした（{message}）': { en: 'Could not save the backup ({message}).' },
  '現在のキャンバスに上書きしてよろしいですか？': { en: 'Overwrite the current canvas?' },
  '非対応のバックアップデータです': { en: 'This backup is not supported.' },
  'イラストのバックアップを復元できませんでした（{message}）': { en: 'Could not restore the backup ({message}).' },
  'ログの保存に失敗しました': { en: 'Could not save the log.' },
  'メモリ不足です': { en: 'Not enough memory.' },
  '結合先レイヤーの合成モードが「通常」ではないため結合できません': { en: 'Cannot merge because the lower layer is not in Normal blend mode.' },
  '下のレイヤーと結合してよろしいですか？（※元に戻せません）': { en: 'Merge down? This cannot be undone.' },
  'ルームに参加できませんでした': { en: 'Could not join the room.' },
  'サーバーの容量節約のためイラストの投稿頻度が制約されています。しばらくしてから再度お試しください。': { en: 'Posting is temporarily limited. Please try again later.' },
  'イラストの投稿に失敗しました。\n{status}: {message}': { en: 'Could not post the work.\n{status}: {message}' },
  'ログインが必要です': { en: 'Please log in.' },
  '入力内容が不適切です': { en: 'Invalid input.' },
  'この操作を行う権限がありません': { en: 'You do not have permission to do this.' },
  'サーバーエラーが発生しました': { en: 'A server error occurred.' },
  '対象が見つかりませんでした': { en: 'The requested item was not found.' },
  'アルバムに追加できるイラストは{limit}件までです': { en: 'Albums can contain up to {limit} works.' },
  'アルバムIDが不適切です': { en: 'Invalid album ID.' },
  'イラストIDが不適切です': { en: 'Invalid work ID.' },
  'このイラストは追加済みです': { en: 'This work is already in the album.' },
  'アルバム名は{limit}文字以内で入力してください': { en: 'Album names can be up to {limit} characters.' },
  '公開設定が不適切です': { en: 'Invalid visibility setting.' },
  'イラストの並び順が不適切です': { en: 'Invalid work order.' },
  'アルバムの並び順が不適切です': { en: 'Invalid album order.' },
  'ユーザーIDが不適切です': { en: 'Invalid user ID.' },
  'ページ番号が不適切です': { en: 'Invalid page number.' },
  '作成できるアルバムは{limit}件までです': { en: 'You can create up to {limit} albums.' },
  '先にパスワードを設定してください': { en: 'Set a password first.' },
  'ログイン試行回数の上限に達したため、しばらくしてから再度お試しください': { en: 'Too many login attempts. Please try again later.' },
  'ユーザーIDまたはパスワードが間違っています': { en: 'Incorrect user ID or password.' },
  'このアカウントは退会済みです': { en: 'This account has been deleted.' },
  'このメッセージは投稿できません': { en: 'This message cannot be posted.' },
  'このプロフィールは設定できません': { en: 'This profile cannot be saved.' },
  'コメントが長すぎます': { en: 'The comment is too long.' },
  '同じイラストに投稿できるコメントは5件までです': { en: 'You can post up to 5 comments on the same work.' },
  'コメントの内容が不適切な可能性があります。表現を修正のうえ再度送信してください。': { en: 'This comment may be inappropriate. Please revise it.' },
  'ピンできるのは5件までです': { en: 'You can pin up to 5 works.' },
  '画像ファイルがありません': { en: 'No image file was provided.' },
  '画像ファイルが不適切です': { en: 'Invalid image file.' },
  '画像の内容が不適切です': { en: 'Invalid image content.' },
  'タイトルを入力してください': { en: 'Enter a title.' },
  'コメントが見つかりません': { en: 'Comment not found.' },
  'イラストが見つかりません': { en: 'Work not found.' },
  'イラストを更新できませんでした': { en: 'Could not update the work.' },
  'ログアウトに失敗しました': { en: 'Could not log out.' },
  'タグ名を入力してください': { en: 'Enter a tag.' },
  '人気タグを取得できませんでした': { en: 'Could not load popular tags.' },
  'リクエストIDが不正です。': { en: 'Invalid request ID.' },
  'ステータスが不正です。': { en: 'Invalid status.' },
  '申告内容が不正です。': { en: 'Invalid response.' },
  'コメントを入力してください。': { en: 'Enter a comment.' },
  'コメントは{limit}文字以内で入力してください。': { en: 'Comments can be up to {limit} characters.' },
  '対象のリクエストが見つかりません。': { en: 'Request not found.' },
  'このリクエストはすでに再開済みです。': { en: 'This request has already been resumed.' },
  '承認済みリクエストのみ再開できます。': { en: 'Only approved requests can be resumed.' },
  '再開可能日時になるまで利用再開できません。': { en: 'You cannot resume access yet.' },
  '現在は新規リクエストを作成できません。': { en: 'You cannot create a new request yet.' },
  '利用停止中のユーザーのみコメントを作成できます。': { en: 'Only suspended users can comment here.' },
  '審査中のリクエストのみ判定できます。': { en: 'Only pending requests can be reviewed.' },
  'ユーザーが見つかりません。': { en: 'User not found.' },
  '-': { en: '-' },
  'ブラウザで遊べる絵チャット': { en: 'DrawTalk' },
  '（令和最新版）': { en: ' Live' },
  'プライベートルームとは': { en: 'About private rooms' },
  'URLを知っているユーザーのみが入室可能です': { en: 'Only people with the URL can enter.' },
  '投稿したイラストは通常のルームのイラストと同じくプロフィールに掲載されます': { en: 'Posted works will appear on your profile.' },
  'プライベートルームの作成が完了しました！': { en: 'Private room created!' },
  '新ブラシを全体適用しました': { en: 'The new brush is now available to everyone.' },
  '入室履歴の整理': { en: 'Edit room history' },
  '選択した入室履歴を削除': { en: 'Delete selected history' },
  '（{count}人）': { en: '({count})' },
  '『{title}』にリアクション': { en: 'React to “{title}”' },
  '{name}さんのアルバム一覧': { en: "{name}'s albums" },
  'メニュー': { en: 'Menu' },
  'メニューを開く': { en: 'Open menu' },
  'ホーム': { en: 'Home' },
  'イラスト': { en: 'Works' },
  'トーク': { en: 'Chat' },
  '利用内容に問題が確認されたため利用が制限されています': { en: 'Access has been restricted due to a policy violation.' },
  '利用停止の解除リクエスト': { en: 'Request review' },
  '利用が制限されています': { en: 'Access restricted' },
  '{name}さんがイラストを投稿しました！': { en: '{name} posted a work!' },
  '{name}さんが入室しました': { en: '{name} joined' },
  'このブラウザは通知機能に対応していません。': { en: 'This browser does not support notifications.' },
  'ブラウザで通知がブロックされています。ブラウザの設定から通知の許可を変更してください。': { en: 'Notifications are blocked. Allow them in your browser settings.' },
  '通知の登録に失敗しました。ブラウザの通知許可設定を確認してください。': { en: 'Could not enable notifications. Check your browser settings.' },
  'このブラウザでプッシュ通知を受け取るための登録を行います。': { en: 'Enable push notifications in this browser.' },
  'ブラウザの確認ダイアログが表示されたら「許可」を選択してください。': { en: 'Select “Allow” when your browser asks for permission.' },
  '通知を完全に解除する場合、ブラウザの設定から通知の許可を変更してください。': { en: 'To disable notifications completely, update your browser settings.' },
  'イラストを削除': { en: 'Delete work' },
  'カバー画像': { en: 'Cover image' },
  'カバー画像を解除': { en: 'Remove cover image' },
  'アイコン': { en: 'Profile image' },
  'アイコンを解除': { en: 'Remove profile image' },
  '「{name}」に追加しました': { en: 'Added to “{name}”.' },
  '既に追加済みです': { en: 'Already added.' },
  '本人': { en: 'Owner' },
  'ユーザー{id}': { en: 'User {id}' },
  '非公開（自分のみ）': { en: 'Private (only you)' },
  'イラストがまだありません': { en: 'No works yet' },
  '『{title}』にスタンプをつけた人': { en: 'Reactions on “{title}”' },
  '{stamp}のスタンプをすべて削除': { en: 'Delete all {stamp} reactions' },
  'この種類のスタンプをすべて削除': { en: 'Delete all reactions of this type' },
  '{name}さんのイラスト一覧': { en: "{name}'s works" },
  '「#{tag}」タグのイラスト一覧': { en: 'Works tagged #{tag}' },
  '{name}を一番上へ': { en: 'Move {name} to the top' },
  '{name}を上へ': { en: 'Move {name} up' },
  '{name}を下へ': { en: 'Move {name} down' },
  '{name}を一番下へ': { en: 'Move {name} to the bottom' },
  '{name}をアルバムから外す': { en: 'Remove {name} from album' },
  'トップに戻る': { en: 'Back to home' },
  '新規リクエスト作成': { en: 'New review request' },
  'カテゴリ': { en: 'Category' },
  '違反行為は行っていない': { en: 'I did not violate the rules' },
  '違反行為に心当たりがある': { en: 'I may have violated the rules' },
  '「違反行為は行っていない」を選択しているにも関わらず違反行為が発見された場合、リクエストは却下されます': { en: 'Your request will be denied if our review finds a violation.' },
  '「違反行為に心当たりがある」を選択した場合、自身で認識している問題行為をコメントに記載してください': { en: 'Describe the behavior you believe may have violated the rules.' },
  'コメント（{requirement}）': { en: 'Comment ({requirement})' },
  '必須': { en: 'required' },
  '任意': { en: 'optional' },
  '注意事項': { en: 'Important' },
  'サブアカウントを含めた全ての利用内容を確認しますので、虚偽の申告が承認されることはありません': { en: 'We review activity across all related accounts, so false claims will not be approved.' },
  'リクエストが承認されると、即時、または違反内容を考慮して決定された時間を経過後に利用を再開することができます': { en: 'If approved, access can resume immediately or after a waiting period based on the violation.' },
  'リクエストが却下されると、48時間経過するまで再度リクエストを送ることはできません': { en: 'If denied, you must wait 48 hours before submitting another request.' },
  '進行中のリクエスト': { en: 'Current request' },
  '作成日時': { en: 'Created' },
  '申告': { en: 'Statement' },
  'ステータス': { en: 'Status' },
  '審査中': { en: 'Pending' },
  '承認': { en: 'Approved' },
  '却下': { en: 'Denied' },
  'リクエストが承認されました。': { en: 'Your request was approved.' },
  '以降に利用を再開できます。': { en: 'or later, you can resume access.' },
  'リクエストが却下されました。': { en: 'Your request was denied.' },
  '以降に再度解除リクエストを作成できます。': { en: 'or later, you can submit another request.' },
  '運営の判定待ちです。': { en: 'Your request is awaiting review.' },
  '利用を再開': { en: 'Resume access' },
  'コメント一覧': { en: 'Comments' },
  'あなた': { en: 'You' },
  '運営': { en: 'Support' },
  'コメントはまだありません。': { en: 'No comments yet.' },
  'コメント追加': { en: 'Add a comment' },
  '運営からの返答があるまでコメントは送信できません': { en: 'You can comment again after support replies.' },
  '通知を受け取る': { en: 'Get notifications' },
  '解除リクエストを送信しました。': { en: 'Review request submitted.' },
  '通常': { en: 'Normal' },
  '乗算': { en: 'Multiply' },
  'スクリーン': { en: 'Screen' },
  '加算': { en: 'Add' },
  'ブラウザ上でお絵描きチャットができるサイトです。': { en: 'Draw and chat together, right in your browser.' },
  '高機能なキャンバスで本格的なイラストを描いたり、チャットやスタンプで交流を楽しもう！': { en: 'Create with powerful drawing tools, then connect through chat and reactions.' },
  '見学してみる': { en: 'Take a look' },
  'はじめる': { en: 'Get started' },
  '{count}人がオンライン': { en: '{count} online' },
  '絵チャット': { en: 'DrawTalk' },
  '最近の注目イラスト': { en: 'Featured works' },
  'もっと見る': { en: 'Show more' },
  'コミュニケーション機能': { en: 'Community features' },
  '使い方ガイド': { en: 'Guides' },
  'お問い合わせ': { en: 'Contact' },
  '利用規約': { en: 'Terms of Service' },
  'プライバシーポリシー': { en: 'Privacy Policy' },
  'お絵描きチャット - 高機能なキャンバスで本格的なイラストを描いたり、チャットやスタンプで交流を楽しもう！': { en: 'Draw together online with powerful tools, live chat, and reactions.' },
  '{page}｜{site}': { en: '{page} | {site}' },
  '{site}の利用規約です。': { en: 'Terms of Service for {site}.' },
  '{site}におけるユーザー情報の取り扱いについてご案内します。': { en: 'Learn how {site} handles your information.' },
  'キャンバス、アカウント、利用停止など、絵チャットに関するよくある質問をまとめています。': { en: 'Answers to common questions about drawing tools, accounts, suspensions, and more.' },
  'ペン、消しゴム、塗りつぶし、選択、レイヤーなど、絵チャットのペイントツールの使い方を紹介します。': { en: 'Learn how to use pens, erasers, fills, selections, layers, and other drawing tools.' },
  'トップへ戻る': { en: 'Back to home' },
  'PAINT GUIDE': { en: 'PAINT GUIDE' },
  '各ツールでできることと、設定の使い分けを紹介します。': { en: 'Learn what each tool does and how to choose the right settings.' },
  'プロフィールの取得に失敗しました': { en: 'Could not load the profile.' },
  '作品を侮辱するコメントをAIが検知した場合に利用停止となります。': { en: 'AI-detected insults or harassment may result in account suspension.' },
  'また、ジョークや悪ノリ、自虐などが批判的コメントとして誤検知される場合がありますのでご注意ください。': { en: 'Jokes, sarcasm, and self-deprecating remarks may also be misidentified, so please word comments carefully.' },
  'アカウントを削除しますか？': { en: 'Delete your account?' },
  'このアカウントと、投稿されたイラストやコメントが削除され、二度と利用できなくなります。': { en: 'Your account, posted works, and comments will be permanently deleted.' },
  'この操作は取り消せません。': { en: 'This action cannot be undone.' },
  '上記について確認しました': { en: 'I understand the above' },
  'アカウントを削除する': { en: 'Delete account' }
} as const
